import format   from 'date-fns/format'
import isLocale from 'date-fns/locale/is'

function simpleDate (dstr: string|Date, weekday = false): string {
	return format(new Date(dstr), (weekday ? 'EEE ' : '') + 'do MMM', { locale: isLocale })
}

export default simpleDate